import { MutableRefObject, useEffect, useRef } from "react";
import CommonPrefetchedData from "../helpers/PrefetchedData/CommonPrefetchedData";
import queuePrefetchData from "../helpers/queuePrefetchData";
import { SharePayloadData } from "../types";

export type Prefetched = MutableRefObject<Record<string, CommonPrefetchedData>>;
const usePrefetchData = (data: SharePayloadData): Prefetched => {
	const prefetched = useRef<Record<string, CommonPrefetchedData>>({});

	useEffect(() => {
		queuePrefetchData(data, prefetched.current);
	}, [data]);

	return prefetched;
};
export default usePrefetchData;
